// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs_2_Gj5","tabs__item":"Tabs_tabs__item_rkumI","tabs__item_active":"Tabs_tabs__item_active_3bnMY"};